import { FETCH_OFFER_SUCCESS } from 'constants/index';
import type { SingleOffer } from 'models';

type OfferAction = {
  type: typeof FETCH_OFFER_SUCCESS;
  payload: {
    entities: {
      offers: Record<string, SingleOffer>;
    };
    result: string;
  };
};

export const selectedOffer = (
  state: SingleOffer | Record<string, never> = {},
  action: OfferAction,
) => {
  switch (action.type) {
    case FETCH_OFFER_SUCCESS: {
      const {
        entities: { offers },
        result,
      } = action.payload;

      return { ...state, ...offers[result] };
    }
    default: {
      return state;
    }
  }
};
